var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"multi-line":_vm.$store.state.infobar.multi_line,"color":_vm.$store.state.infobar.type === 'error'
      ? 'error darken-3'
      : _vm.$store.state.infobar.type === 'success'
      ? 'success'
      : _vm.$store.state.infobar.type === 'info'
      ? 'info'
      : '',"right":""},model:{value:(_vm.infobarStatus),callback:function ($$v) {_vm.infobarStatus=$$v},expression:"infobarStatus"}},[_c('v-avatar',[_c('v-icon',{attrs:{"dark":""}},[_vm._v(_vm._s(_vm.$store.state.infobar.type === "error"
        ? "error"
        : _vm.$store.state.infobar.type === "success"
        ? "check_circle"
        : _vm.$store.state.infobar.type === "info"
        ? "info"
        : ""))])],1),_vm._v("\n  "+_vm._s(_vm.$store.state.infobar.text)+"\n  "),_c('v-spacer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }